var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CellModule } from '../cell/cell.module';
import { Ng2SmartTableTbodyComponent } from './tbody.component';
import { TbodyCreateCancelComponent } from './cells/create-cancel.component';
import { TbodyEditDeleteComponent } from './cells/edit-delete.component';
var TBODY_COMPONENTS = [
    TbodyCreateCancelComponent,
    TbodyEditDeleteComponent,
    Ng2SmartTableTbodyComponent,
];
var TBodyModule = (function () {
    function TBodyModule() {
    }
    return TBodyModule;
}());
TBodyModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            CellModule,
        ],
        declarations: TBODY_COMPONENTS.slice(),
        exports: TBODY_COMPONENTS.slice(),
    })
], TBodyModule);
export { TBodyModule };
//# sourceMappingURL=tbody.module.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-smart-table/components/tbody/tbody.module.js
// module id = ../../../../ng2-smart-table/components/tbody/tbody.module.js
// module chunks = 37